import React, { createContext, useState, useContext } from 'react';

interface LogoContextType {
  logoInHeader: boolean;
  setLogoInHeader: React.Dispatch<React.SetStateAction<boolean>>;
  logoClicked: boolean;
  setLogoClicked: React.Dispatch<React.SetStateAction<boolean>>;
  isAnimating: boolean;
  setIsAnimating: React.Dispatch<React.SetStateAction<boolean>>;
  isSrivatsaView: boolean;
  setIsSrivatsaView: React.Dispatch<React.SetStateAction<boolean>>;
}

const LogoContext = createContext<LogoContextType | undefined>(undefined);

export const LogoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [logoInHeader, setLogoInHeader] = useState(false);
  const [logoClicked, setLogoClicked] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isSrivatsaView, setIsSrivatsaView] = useState(false);

  return (
    <LogoContext.Provider value={{ 
      logoInHeader, 
      setLogoInHeader,
      logoClicked,
      setLogoClicked,
      isAnimating,
      setIsAnimating,
      isSrivatsaView,
      setIsSrivatsaView
    }}>
      {children}
    </LogoContext.Provider>
  );
};

export const useLogo = (): LogoContextType => {
  const context = useContext(LogoContext);
  if (context === undefined) {
    throw new Error('useLogo must be used within a LogoProvider');
  }
  return context;
};
